module.exports = __webpack_public_path__ + "img/swords.41bbaeea.svg";